export default __webpack_public_path__ + "static/media/option-icon.8e55f919.svg";